module.exports = __webpack_public_path__ + "static/imperfect-courage-6acb664a2461d5b5775232425272ffef.jpg";